var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"krpanoWrap"},[_c('div',{attrs:{"id":"pano"}}),(_vm.showRemind)?_c('div',{staticClass:"mask",on:{"click":_vm.playaudio}},[_c('div',{staticClass:"remindBtn"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }